import React from "react";

import { NEW_RULE_TYPES } from "globals/constants";
import { useRuleBuilderContext } from "containers/Rules/context/useRuleBuilderContext";
import { useTruncatedAndFullLabels } from "./useTruncatedAndFullLabels";

export const useConditionText = (rule) => {
    const { formElements } = useRuleBuilderContext();
    const { truncatedLabel } = useTruncatedAndFullLabels({
        formElementId: rule.formElementId,
        optionId: rule.optionId,
        formElements,
    });

    switch (rule.ruleType) {
        case NEW_RULE_TYPES.ANSWERED:
        case NEW_RULE_TYPES.RT_ROLE:
            return <>{truncatedLabel}</>;
        default:
            return <>{`If ${truncatedLabel}`}</>;
    }
};
